import React from "react";

export default function CreatePractitioner() {
  return (
    <>
      <h2>Create New Practitioner</h2>
    </>
  );
}
